import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '!isomorphic-style-loader!css-loader!./DayCalendar.css';
import { stub } from 'mocktail';

export default stub(withStyles(s), d => d);



// WEBPACK FOOTER //
// ./src/components/DayCalendar/DayCalendarStyles.js